type WorkiomTablePaginationProps = {
  page: number;
  pageSize: number;
  totalRows: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
  showAllOption?: boolean;
};

export function WorkiomTablePagination({ page, pageSize, totalRows, onPageChange, onPageSizeChange, showAllOption = false }: WorkiomTablePaginationProps) {
  const totalPages = Math.max(1, Math.ceil(totalRows / pageSize));
  const start = totalRows === 0 ? 0 : (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, totalRows);

  return (
    <div className="flex items-center justify-between gap-3 px-4 py-2 border-t border-gray-200 bg-gray-50">
      <div className="text-xs text-gray-600">
        {start}-{end} / {totalRows}
      </div>
      <div className="flex items-center gap-2">
        <select
          value={String(pageSize)}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
          className="text-xs border border-gray-300 rounded px-2 py-1"
        >
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
          <option value="100">100</option>
          {showAllOption && <option value={String(Math.max(totalRows, 100))}>Tümü</option>}
        </select>
        <button
          onClick={() => onPageChange(Math.max(1, page - 1))}
          disabled={page <= 1}
          className="px-2 py-1 text-xs border border-gray-300 rounded disabled:opacity-50"
        >
          Geri
        </button>
        <span className="text-xs text-gray-700">{page} / {totalPages}</span>
        <button
          onClick={() => onPageChange(Math.min(totalPages, page + 1))}
          disabled={page >= totalPages}
          className="px-2 py-1 text-xs border border-gray-300 rounded disabled:opacity-50"
        >
          İleri
        </button>
      </div>
    </div>
  );
}
